import Vue from 'vue'

import App from './App.vue'
import router from './router'

Vue.config.productionTip = false

import "./assets/css/common.css";

// 引入elementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 引用animate.css
import animated from 'animate.css' 
Vue.use(animated)

// 引入头部组件
import myheader from './components/myheader';
Vue.use(myheader);

// 引入MintUI
import MintUI from 'mint-ui';
import 'mint-ui/lib/style.css';
Vue.use(MintUI);

//引入swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.min.css'
Vue.use(VueAwesomeSwiper)

import global_ from './components/Global'//引用文件
Vue.prototype.nyy = global_//挂载到Vue实例上面

new Vue({
  router,
  render: function (h) { return h(App) }
}).$mount('#app')

